import React, { useEffect, useState, useRef } from 'react';
import { useNav } from '../../hooks/nav';
import './style.scss';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { colors } from 'src/styles/colors';
import { useStore } from 'src/onboarding/store/store';
import Analytics from '@web-solutions/module-analytics';

const Page = () => {
  const [percentage, setPercentage] = useState(0);
  const [activeBar, setActiveBar] = useState(0);

  const animationRef = useRef({
    hasCompleted: false,
    animationId: null,
  });
  const startTimeRef = useRef(performance.now());

  const gender = useStore((state) => state.gender);

  const { onNext, currentIndex } = useNav();

  useEffect(() => {
    const duration = 3000;

    const animate = (time) => {
      const progress = Math.min((time - startTimeRef.current) / duration, 1);
      const newPercentage = Math.round(progress * 100);
      setPercentage(newPercentage);

      if (newPercentage < 25) {
        setActiveBar(0);
      } else if (newPercentage >= 25 && newPercentage < 50) {
        setActiveBar(1);
      } else if (newPercentage >= 50 && newPercentage < 75) {
        setActiveBar(2);
      } else if (newPercentage >= 75) {
        setActiveBar(3);
      }

      if (newPercentage >= 100 && !animationRef.current.hasCompleted) {
        animationRef.current.hasCompleted = true;
        cancelAnimationFrame(animationRef.current.animationId);
        Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
            page: 'analyzing-activity',
          });
        onNext();
        return;
      }

      if (progress < 1) {
        animationRef.current.animationId = requestAnimationFrame(animate);
      }
    };

    animationRef.current.hasCompleted = false;
    animationRef.current.animationId = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current.animationId) {
        cancelAnimationFrame(animationRef.current.animationId);
      }
    };
  }, [onNext]);

  return (
    <div className='layout analyzing-page'>
      <div style={{ marginTop: '40px', marginBottom: '8px' }}>
        <div style={{ position: 'relative', width: 145, height: 145, margin: '0 auto' }}>
          <CircularProgressbar
            value={percentage}
            styles={buildStyles({
              pathColor: 'rgb(0, 206, 0)',
              trailColor: colors.baseWhite,
              strokeLinecap: 'round',
            })}
            text={''}
          />
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: 40,
              lineHeight: '40px',
              letterSpacing: '-0.032px',
              fontWeight: 700,
              fontFamily: 'Inter',
            }}
          >
            {percentage}%
          </div>
        </div>
      </div>
      <div style={{ padding: '0 20px' }}>
        <Title tag='h2'>{t('onboarding.analyzingActivity.title')}</Title>
      </div>
    </div>
  );
};

export default Page;
